__webpack_require__.p = "/connection-speed-test/";